import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthenticationService } from 'app/core/auth/services/authentication.service';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ErrorHttpInterceptor implements HttpInterceptor {
  constructor(
    private readonly _authenticationService: AuthenticationService,
    private readonly _toastr: ToastrService,
  ) {}
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const requestUrl = request.url as any;
    if (
      requestUrl.match(/auth\/login_check/) ||
      requestUrl.match(/auth\/login/) ||
      requestUrl.match(/user\/me/) ||
      requestUrl.match(/auth\/sso\/saml\/exchange/) ||
      requestUrl.match(/auth\/sso\/oidc\/exchange/)
    ) {
      return next.handle(request);
    }
    return next.handle(request).pipe(
      catchError((err) => {
        console.log('catchError', err);
        if (err.status === 401) {
          this._authenticationService.logout();
          location.reload();
        }
        // check statuses backoffice
        if (err.status >= 403 && err.status < 500) {
          if (environment.authBounceForceLogout) {
            console.warn('status error http: ', err.status);
            this._authenticationService.logout();
            location.reload();
          } else if (err.status === 406) {
            throw err.error;
          } else {
            this._toastr.error('Si è verificato un errore del server');
          }
        } else {
          this._toastr.error('Si è verificato un errore del server');
        }
        const error = err.error?.message || err.error || err.statusText;
        throw error;
      }),
    );
  }
}
